import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=0437b2dc&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=0437b2dc&prod&scoped=true&lang=css"
import style1 from "./Layout.vue?vue&type=style&index=1&id=0437b2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0437b2dc",
  null
  
)

export default component.exports